//引入axios
import axios from 'axios'
import {
  Message
} from 'element-ui'

//判断是否是生产环境
var isPro = process.env.NODE_ENV === 'production' //process.env.NODE_ENV用于区分是生产环境还是开发环境

//根据环境不同导出不同的baseURL
let baseURL = isPro ? '/admin' : '/admin'

//创建一个新的axios实例
const service = axios.create({
  baseURL: baseURL,
  //设置超时时间，超过该时间就不会发起请求
  timeout: 30000
})
service.interceptors.request.use(
  config => {
    config.headers = {
      'Content-Type': 'application/json',//配置请求头
    }
    config.headers["token"] = localStorage.token //配置token
   //语言标识
    config.headers['Accept-Language'] =localStorage.language ||"zh"
    // config.headers['Accept-Language'] ='en'
    // config.headers['Accept-Language'] ='zh'
    return config
  },
  error => {
    console.log(error);
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  //请求成功处理
  response => {
    const res = response
    if (res.data.code === 1) {
      return res.data
    } else {
      return res.data
    }
  },
  error => {
    if (JSON.stringify(error).includes('timeout')) {
      Message.error(error.response.data.msg)
      if (error.response.data.code == '401') {
        localStorage.clear()
        setTimeout(() => {
          location.reload()
        }, 1000)
      }
    }
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js